import { z } from "zod";

import { nodeActionSchema } from "../actions/index.ts";
import { semverSchema } from "../shared/index.ts";

export const applyRevisionSchema = z.object({
  revision: z.number(),
  actions: z.array(nodeActionSchema),
  createdOn: z.date({ coerce: true }),
  appVersion: semverSchema,
  checksum: z.number().int(), // this could be derived from actions but would need to canonicalize
});

export type ApplyRevision = z.infer<typeof applyRevisionSchema>;
